import List from '@material-ui/core/List';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import ListIcon from '@material-ui/icons/List';
import SvgIcon from '@material-ui/core/SvgIcon';
import SupportIcon from '@material-ui/icons/Support';
import EmailIcon from '@material-ui/icons/Email';
import MarkEmailReadIcon from '@material-ui/icons/MarkEmailRead';
import LinkIcon from '@material-ui/icons/AddLink';
import { useState } from 'react';
import BoltOutlinedIcon from '@material-ui/icons/BoltOutlined';

import { useStyles } from './styles';
import ListItemLink from '../ListItemLink';
import { PixelIcon, ReportsIcon } from '../../assets/icons';
import { appPermissions, useAccess } from '../../hooks/useAccess';
import CampaignIcon from '@material-ui/icons/Campaign';
import DomainIcon from '@material-ui/icons/Domain';
import AdminPanelSettingsIcon from '@material-ui/icons/AdminPanelSettings';
import QueryStatsIcon from '@material-ui/icons/QueryStats';

import { Warning, Rowing, AlignHorizontalLeft } from '@material-ui/icons';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExtensionIcon from '@material-ui/icons/Extension';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import HowToRegIcon from '@material-ui/icons/HowToReg';

const Navigation = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };
  const classes = useStyles();
  const { hasPermission } = useAccess();

  return (
    <Drawer
      variant="permanent"
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        <List disablePadding>
          <ListItemLink
            icon={<SvgIcon component={PixelIcon} />}
            primary="Pixel Management"
            to="/pixel"
          />
          <ListItemLink
            icon={<SvgIcon component={ReportsIcon} />}
            primary="Pixel Reports"
            to="/pixel-reports"
          />
          <ListItemLink
            icon={<BoltOutlinedIcon />}
            primary="Trigger Management"
            to="/trigger-manager"
          />
          <ListItemLink
            icon={<SvgIcon component={AlignHorizontalLeft} />}
            primary="Trigger Reports"
            to="/trigger-reports"
          />
          <ListItemLink
            icon={<SvgIcon component={FileCopyIcon} />}
            primary="Report Downloads"
            to="/reports/all"
          />
          {hasPermission(appPermissions.networkIn) && (
            <ListItemLink
              icon={<ListIcon />}
              primary="List Management"
              to="/list-manager"
            />
          )}
          <ListItemLink
            icon={<SvgIcon component={ExtensionIcon} />}
            primary="Integrations"
            to="/integrations"
          />
          <ListItemLink
            icon={<SvgIcon component={MarkEmailReadIcon} />}
            primary="Activity Checker"
            to="/activity-checker"
          />
          <li>
            <a
              href="https://support.inboxmailers.com/"
              rel="noreferrer"
              target="_blank"
              className={classes.offSiteLink}
            >
              <SupportIcon />
              <span className={classes.OffSiteLinkText}>Support</span>
            </a>
          </li>
          {hasPermission(appPermissions.adminRole) && (
            <>
              <ListItemButton
                onClick={handleClick}
                className={open ? classes.adminTabOpen : classes.adminTabClosed}
              >
                <ListItemIcon>
                  <HowToRegIcon />
                </ListItemIcon>
                <ListItemText primary="Admin" />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div">
                  <ListItemLink
                    icon={<SvgIcon component={Warning} />}
                    primary="Admin Creatives"
                    to="/admin-templates"
                    isAdmin={true}
                  />
                  <ListItemLink
                    icon={<SvgIcon component={Rowing} />}
                    primary="Partner Activity"
                    to="/partner-activity"
                    isAdmin={true}
                  />
                  <ListItemLink
                    icon={<AdminPanelSettingsIcon />}
                    primary="Admin Partner Trigger View"
                    to="/admin-trigger-view"
                    isAdmin={true}
                  />
                  <ListItemLink
                    icon={<QueryStatsIcon />}
                    primary="Trigger Stats"
                    to="/trigger-stats"
                    isAdmin={true}
                  />
                  <ListItemLink
                    icon={<SvgIcon component={ExtensionIcon} />}
                    primary="Admin Partner Integration View"
                    to="/admin-integration"
                    isAdmin={true}
                  />
                  <ListItemLink
                    icon={<ListIcon />}
                    primary="Admin Partner Lists View"
                    to="/admin-lists"
                    isAdmin={true}
                  />
                  <ListItemLink
                    icon={<SvgIcon component={Rowing} />}
                    primary="Admin Partners View"
                    to="/admin-partner"
                    isAdmin={true}
                  />
                </List>
              </Collapse>
            </>
          )}
        </List>
      </div>
    </Drawer>
  );
};

export default Navigation;
